"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetalsWorkOrderInstruction = exports.MetalsWorkOrder = void 0;
const Utils_1 = require("./Utils");
const model_core_1 = require("@nxt/model-core");
const index_1 = require("../index");
class MetalsWorkOrder extends model_core_1.WorkOrder {
    client_id = ''; // Deprecate
    order_id = ''; // Deprecate
    agent_id = ''; // Deprecate
    location_id = ''; // Deprecate
    worker_id = ''; // Deprecate
    state = 'Draft';
    stages = [];
    notes = '';
    document = '';
    instructions = new model_core_1.ChildArray();
    order = null;
    location = null;
    get stage() {
        return (this._stage !== undefined) ? this._stage : (this.state) ? Utils_1.WORK_ORDER_STAGES[this.state] : null;
    }
    set stage(i) {
        if (i !== this._stage) {
            this._stage = i;
            this.state = Utils_1.WORK_ORDER_STAGE_MAP[i] || '';
        }
    }
    _stage;
    constructor(data, olMap) {
        super(data, olMap || index_1.olm);
        (0, model_core_1.setObjectProperties)(this, data, olMap || index_1.olm, MetalsWorkOrder);
        this._stage = data?.data ? data.data()?.stage : data?.stage || 0;
        this.state = Utils_1.WORK_ORDER_STAGE_MAP[this._stage] || '';
        try {
            Object.keys(Utils_1.WORK_ORDER_STAGES).forEach((stage) => {
                if (!this.stages[Utils_1.WORK_ORDER_STAGES[stage]]) {
                    this.stages[Utils_1.WORK_ORDER_STAGES[stage]] = {};
                }
            });
            if (this.stages.length > Utils_1.WORK_ORDER_STAGES.length) {
                this.stages.splice(Utils_1.WORK_ORDER_STAGES.length - 1);
            }
        }
        catch (e) {
        }
    }
    async convert(opts) {
        if (this.order?.id) {
            this.order = new index_1.MetalsOrder(await this._docRef.parent.parent.collection('orders').doc(this.order.id).get());
        }
        await this.save();
    }
    async loadAll(opts, stack) {
        opts = opts || {};
        opts.loadAllFn = opts.loadAllFn || index_1.loadAll;
        opts.olm = opts.olm || index_1.olm;
        return super.loadAll(opts, stack);
    }
    toString() {
        return `WorkOrder: ${this.workers?.map(w => w.name).join(';')}: ${this.order?.invoice_id}: ${this.state}`;
    }
    toJSON() {
        let r = super.toJSON();
        r.stage = this.stage;
        ['location', 'agent', 'worker', 'order'].forEach(p => {
            r[p] = (0, model_core_1.toMinJSON)(this, p);
            // Deprecate eventually.
            if (r[p] && r[p].id) {
                r[`${p}_id`] = r[p].id;
            }
        });
        ['stateMap', 'instructions', 'order'].forEach(p => delete r[p]);
        return r;
    }
}
exports.MetalsWorkOrder = MetalsWorkOrder;
class MetalsWorkOrderInstruction extends model_core_1.Base {
    index = null;
    name = '';
    description = '';
    variant_number = '';
    order_id = '';
    work_order_id = '';
    inventory_id = '';
    variant_id = '';
    piece_id = '';
    item_id = '';
    location_id = '';
    type = '';
    dimensions = new model_core_1.DimensionArray();
    state = 'Draft';
    notes = '';
    total_weight = null;
    date = null;
    order_date = null;
    quantity = null;
    _locations;
    _order;
    set stage(i) {
        if (i !== this._stage) {
            this._stage = i;
            this.state = Utils_1.WORK_ORDER_STAGE_MAP[i] || '';
        }
    }
    get stage() {
        return (this._stage !== undefined) ? this._stage : (this.state) ? Utils_1.WORK_ORDER_STAGES[this.state] : null;
    }
    _stage;
    constructor(data, olMap) {
        super('instructions', 10);
        (0, model_core_1.setObjectProperties)(this, data, olMap || index_1.olm, MetalsWorkOrderInstruction);
    }
    toJSON() {
        let r = super.toJSON();
        r.stage = this.stage;
        return r;
    }
}
exports.MetalsWorkOrderInstruction = MetalsWorkOrderInstruction;
index_1.olm.work_orders = (ref, map) => {
    return new MetalsWorkOrder(ref, map);
};
index_1.olm.instructions = (ref, map) => {
    return new MetalsWorkOrderInstruction(ref, map);
};
